import { render } from "./VerifyProximity.vue?vue&type=template&id=2a59588c&scoped=true&ts=true"
import script from "./VerifyProximity.vue?vue&type=script&lang=ts"
export * from "./VerifyProximity.vue?vue&type=script&lang=ts"

import "./VerifyProximity.vue?vue&type=style&index=0&id=2a59588c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a59588c"]])

export default __exports__